{
  "asset_id": "56bc223f-7b78-4673-9354-b8b5ca695350",
  "content_type": "image/png",
  "created_at": "2026-06-26T13:31:05Z",
  "original_filename": "plan-basic.png",
  "project_id": "1ee18af1-1d84-490c-8b4d-f96ad9f331fc",
  "r2_key": "a/v1/1ee18af1-1d84-490c-8b4d-f96ad9f331fc/56bc223f-7b78-4673-9354-b8b5ca695350/plan-basic.png",
  "size": 132915,
  "url": "/__l5e/assets-v1/56bc223f-7b78-4673-9354-b8b5ca695350/plan-basic.png",
  "version": 1
}